<template>
  <v-card-text>
    <v-text-field v-model="form.name"
                  label="Name"
                  autocomplete="off"
                  outlined
                  dense
                  :disabled="form.busy"
                  :error-messages="form.errors.get('name')"
                  class="mb-4">
    </v-text-field>

    <v-textarea v-model="form.content"
                label="Content"
                autocomplete="off"
                outlined
                rows="5"
                auto-grow
                dense
                :disabled="form.busy"
                :error-messages="form.errors.get('content')"
                class="mb-4">
    </v-textarea>

    <v-autocomplete v-model="form.groups"
                    :items="groups"
                    item-value="id"
                    item-text="name"
                    label="Groups"
                    autocomplete="off"
                    outlined
                    dense
                    deletable-chips
                    small-chips
                    multiple
                    :disabled="form.busy"
                    :error-messages="form.errors.get('groups')">
    </v-autocomplete>

    <v-radio-group v-model="form.status"
                   label="Status"
                   dense
                   class="mt-0 pb-0">
      <v-radio value="Active"
               label="Active">
      </v-radio>
      <v-radio value="Inactive"
               label="Inactive">
      </v-radio>
    </v-radio-group>
  </v-card-text>
</template>
<script>
import {mapGetters} from 'vuex';

export default {
  props: {
    form: {
      type: Object,
      required: true,
    }
  },
  computed: {
    ...mapGetters([
      'groups',
      'team',
      'user',
    ]),
  }
}
</script>
